if(!customElements.get("finance-percent-view")) customElements.define("finance-percent-view", class extends HTMLElement {
    static get observedAttributes() {
        return ['value', 'total'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case "value":
                this.updateText(
                    Number.parseInt(newValue),
                    Number.parseInt(this.getAttribute('total'))
                );
                break;
            case "total":
                this.updateText(
                    Number.parseInt(this.getAttribute('value')),
                    Number.parseInt(newValue)
                );
                break;
        }
    }

    connectedCallback() {
        this.updateText(
            Number.parseInt(this.getAttribute('value')),
            Number.parseInt(this.getAttribute('total'))
        );
    }

    updateText(value, total) {
        if (
            typeof value !== 'undefined' && !Number.isNaN(value) && Number.isFinite(value) &&
            typeof total !== 'undefined' && !Number.isNaN(total) && Number.isFinite(total)
        ) {
            this.innerHTML = `${Math.round(100 * value / total)}%`
        }
    }
});
